import { useState } from 'react';

interface ShareButtonProps {
  roomCode: string;
}

const ShareButton = ({ roomCode }: ShareButtonProps) => {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(false);
  const joinUrl = `${window.location.origin}/join?roomCode=${roomCode}`;

  const handleShare = async () => {
    const shareData = {
      title: 'Join my maxbox.live trivia game!',
      text: `Play trivia with me! Join room ${roomCode} here:`,
      url: joinUrl,
    };

    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
      } catch (err) {
      }
    } else {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(joinUrl);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        } else {
          // Fallback for older browsers or non-secure contexts
          const textArea = document.createElement('textarea');
          textArea.value = joinUrl;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          try {
          const successful = document.execCommand('copy');
          if (successful) {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          } else {
            throw new Error('Copy failed');
        }
    } finally {
      document.body.removeChild(textArea);
          }
        }
      } catch (err) {
        setError(true);
        setTimeout(() => setError(false), 2000);
      }
    }
  };

  return (
    <button
      onClick={handleShare}
      className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition duration-300 text-lg"
    >
      {error ? (
        'Share Failed'
      ) : copied ? (
        'Link Copied!'
      ) : (
        'Invite Friends'
      )}
    </button>
  );
};

export default ShareButton;
